import { createModel } from '@rematch/core';
import type { RootModel } from '@/models';
import { initReduxFn, setStateReducer } from '@/std/redux';
import type { ContasReceberState } from './types';
import { effects } from './effects';

const initialState: ContasReceberState = {
    estornar: initReduxFn,
    estornarLancamento: initReduxFn,
    excluirBoleto: initReduxFn,
    excluirPixCobranca: initReduxFn,
    gerarBoleto: initReduxFn,
    gerarPixCobranca: initReduxFn,
    get: initReduxFn,
    getOne: initReduxFn,
    getTable: {
        // LOADING NA TABELA PARA MOSTRAR ALGUMA AÇÃO EXECUTANDO
        loadingTable: false,

        // PAGINAÇÃO
        pagination: {
            current: 1,
            pageSize: 10,
            showSizeChanger: false,
            showTotal: () => '',
            total: 10,
        },
        qtdRegistros: 10,
        registroInitial: 0,

        // LINHA SELECIONADAS
        selectedRow: undefined,
        selectedRows: [],

        // ORDENAÇÃO
        sortParams: {
            fieldName: '',
            orderDirection: 'asc',
            shouldSort: false,
        },
        // TOTAIS REGISTROS (PARA PAGINAÇÃO)
        totalRegistrosTable: 0,

        // UPDATE TABLE ON CHANGES
        updateTable: false,
    },
    getTotais: initReduxFn,
    pagination: {
        current: 1,
        pageSize: 10,
        showSizeChanger: false,
        showTotal: () => '',
        total: 22,
    },
    post: initReduxFn,
    postAnexo: initReduxFn,
    postLancamento: initReduxFn,
    put: initReduxFn,
    removeAnexo: initReduxFn,
    selectAll: false,
    selectedRowKeys: [],
    selectedRows: [],
    showCompartilhar: false,
    showDrawerCompartilhar: false,
    showDrawerGetDetalhes: false,
    showModal: false,
    showPixCobranca: false,
    showReceber: false,
    showSelectAll: false,
    sortParams: {
        fieldName: '',
        orderDirection: 'asc',
        shouldSort: false,
    },
    tableHistorico: [],
};

export const ContasReceberModel = createModel<RootModel>()({
    effects,
    reducers: setStateReducer<ContasReceberState>(),
    state: initialState,
});
